'use client';

import BlazeSlider from 'blaze-slider';
import 'blaze-slider/dist/blaze.css';
import { useEffect, useRef } from 'react';

export default function Slider({ children, count }) {
  const sliderRef = useRef();

  useEffect(() => {
    const slider = new BlazeSlider(sliderRef.current, {
      all: {
        slidesToShow: 3,
        slideGap: '30px'
      },
      '(max-width: 1023px)': {
        slidesToShow: 1
      },
      '(max-width: 639px)': {
        slidesToShow: 1
      }
    });

    return () => slider.destroy();
  }, [count]);

  return (
    <div className="blaze-slider mt-10 lg:mt-15" ref={sliderRef}>
      <div className="blaze-container max-w-full lg:flex lg:items-center lg:justify-center">
        {count > 1 && (
          <button
            className="blaze-prev blaze-prev-large mr-8 hidden h-[48px] min-w-[48px] bg-black lg:block"
            aria-label="Go to previous slide"
          >
            <span className="sr-only">previous</span>
          </button>
        )}
        <div className="blaze-track-container lg:max-w-container flex max-w-full">
          <ul className="blaze-track relative max-w-[200px] sm:max-w-[280px] lg:max-w-full">
            {children}
          </ul>
        </div>
        {count > 1 && (
          <button
            className="blaze-next blaze-next-large ml-8 hidden h-[48px] min-w-[48px] bg-black lg:block"
            aria-label="Go to next slide"
          >
            <span className="sr-only">next</span>
          </button>
        )}
      </div>

      <div className="blaze-pagination indicators-dark mt-10 flex sm:mt-15" />
    </div>
  );
}
